import { useCallback, useSyncExternalStore } from 'react';
import { useNavigation } from 'expo-router';

/**
 * Subscribes to navigation focus/blur events via `useSyncExternalStore`,
 * reading `navigation.isFocused` as the snapshot. Returns a reactive boolean
 * that updates in sync with the navigation state and avoids tearing during
 * concurrent renders.
 */
export const useIsFocused = (): boolean => {
  const navigation = useNavigation();

  const subscribe = useCallback(
    (callback: () => void) => {
      const unsubscribeFocus = navigation.addListener('focus', callback);
      const unsubscribeBlur = navigation.addListener('blur', callback);

      return () => {
        unsubscribeFocus();
        unsubscribeBlur();
      };
    },
    [navigation],
  );

  return useSyncExternalStore(subscribe, navigation.isFocused, navigation.isFocused);
};
